import React from 'react';
import { ArrowRight } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';

const CLSDKNotFound = () => (
  <ErrorPage
    Header={Header}
    Footer={Footer}
    brandAttr="CLS"
    code="404"
    title="Siden blev ikke fundet"
    description="Siden du leder efter findes ikke eller er blevet flyttet."
    primaryCta={{ label: 'Til forsiden', to: '/clothing/cls-dk', icon: <ArrowRight size={20} /> }}
    secondaryCta={{ label: 'Gå til FAQ', to: '/clothing/cls-dk/faq' }}
  />
);

export default CLSDKNotFound;
